export const profile = {
  Verified: 'Sviluppatore verificato',
  'Experience years': '7 anni di esperienza',
  'Minutes on spotify': '83.194 minuti su Spotify (2024)',
  'About me': 'Su di me',
  'About me description': `🚀 Ingegnere Software Senior 🚀

👨‍💻 Ingegnere Software Senior con 7 anni di esperienza nello sviluppo di applicazioni web e mobili.

📍 Basato a Buenos Aires, Argentina.

💼 Attualmente specializzato in progetti Typescript, coprendo sia lo sviluppo frontend (React.js) che backend (Node.js), con esperienza nello sviluppo mobile (React Native / Ionic / Expo). Inoltre, ho lavorato con altri linguaggi di programmazione come Python e PHP.

⚙️ Appassionato di automazione e miglioramento continuo, ho anche avuto l'opportunità di lavorare su compiti DevOps, ottimizzando i processi e assicurando l'efficienza nel ciclo di vita dello sviluppo software.

🔍 Sempre alla ricerca di nuove sfide e opportunità per applicare le mie competenze tecniche e la mia passione per la tecnologia in ambienti dinamici e collaborativi.
    `,
  'Download CV': 'Scarica il CV',
};
